import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import DefaultImage from "../../assets/images/logo/logo_dark.png";
import { Link } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import { API_URL } from '../../config/api';

ListMasjidSection.propTypes = {
    data: PropTypes.array,
};

function ListMasjidSection(props) {
    const [senaraiMasjid, setSenaraiMasjid]     = useState([]);
    const [page, setPage]                       = useState(1);
    const [pageCount, setPageCount]             = useState(1);
    const [totalCount, setTotalCount]           = useState(0);
    const [loading, setLoading]                 = useState(true);
    const itemsPerPage                          = 12;

    const fetchMasjidList = async (page) => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/portal/senarai-institusi?page=${page}&limit=${itemsPerPage}`, requestOptions);
            const result = await response.json();
            setSenaraiMasjid(result.data.row);
            setPageCount(Math.ceil(result.data.total / itemsPerPage));
            setTotalCount(result.data.total);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMasjidList(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const handlePageChange = (event, value) => {
        setPage(value);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <section className="si-section">
            <div className="tf-container">
                <div className="si-header">
                    <div>
                        <h4 className="si-title">Senarai Institusi</h4>
                        <p className="si-subtitle">
                            {totalCount > 0
                                ? `${totalCount} institusi berdaftar bersama kami`
                                : 'Terokai institusi yang berdaftar bersama kami'}
                        </p>
                    </div>
                </div>

                {loading ? (
                    <div className="si-grid">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div key={i} className="si-card si-card-skeleton">
                                <div className="si-card-media skeleton-block" />
                                <div className="si-card-body">
                                    <div className="skeleton-line" style={{ width: '70%' }} />
                                    <div className="skeleton-line" style={{ width: '40%' }} />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : senaraiMasjid.length === 0 ? (
                    <div className="si-empty">
                        <p>Tiada institusi dijumpai buat masa ini.</p>
                    </div>
                ) : (
                    <div className="si-grid">
                        {senaraiMasjid.map((masjid, index) => (
                            <Link
                                key={index}
                                to={`/institusi/${masjid.organizationCode}`}
                                state={masjid}
                                className="si-card"
                            >
                                <div className="si-card-media">
                                    <img
                                        src={masjid.organizationImage ? masjid.organizationImage : DefaultImage}
                                        alt={masjid.organizationName}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = DefaultImage;
                                        }}
                                    />
                                    <span className="si-card-badge">Institusi</span>
                                </div>
                                <div className="si-card-body">
                                    <h5 className="si-card-name">{masjid.organizationName}</h5>
                                    <span className="si-card-cta">
                                        Lihat maklumat
                                        <i className="fas fa-arrow-right"></i>
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}

                {pageCount > 1 && (
                    <Pagination
                        count={pageCount}
                        page={page}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded"
                        color="primary"
                        className="si-pagination"
                    />
                )}
            </div>
        </section>
    );
}

export default ListMasjidSection;
